import { toBigNumber } from '@injectivelabs/utils';
export class IndexerGrpcReferralTransformer {
    static referrerDetailsResponseToReferrerDetails(address, response) {
        return {
            referrerAddress: address,
            invitees: response.invitees,
            referrerCode: response.referrerCode,
            totalCommission: toBigNumber(response.totalCommission),
            totalTradingVolume: toBigNumber(response.totalTradingVolume),
        };
    }
    static inviteeDetailsResponseToInviteeDetails(response) {
        return response;
    }
    static referrerByCodeResponseToReferrerByCode(response) {
        return response?.referrerAddress || '';
    }
}
